import axios from '../api/index.js';

//注册用户
export let postRegister = (params) => {
    return axios.post(`/sys/user/register`, params);
};

//发送验证码
export let postSendSms = (params) => {
    return axios.post(`/sys/auth/sendSms?mobile=${params}`);
};

//检测是否存在
export let getCheckAccount = (params) => {
    return axios.get(`/client/user/check/${params}`);
};

//用户登录
export let postLogin = (params) => {
    return axios.post(`/sys/auth/client/login`, params);
};

//当前用户
export let getAuthUser = () => {
    return axios.get(`/sys/auth/user`);
};

//获取用户详情
export let getUser = (params) => {
    return axios.get(`/sys/user/${params}`);
};

//个人信息完善
export let putLogin = (params) => {
    return axios.put(`/sys/user`, params);
};

//修改密码
export let putUserPassword = (params) => {
    return axios.put(`/sys/user/password`, params);
};

////////////////舞美个人信息/////////////////
//获取舞美个人信息完善
export let getWmUserInfo = (params) => {
    return axios.get(`/sys/user/wm/info/${params}`);
};

//获取舞美个人信息编辑
export let putWmUserInfo = (params) => {
    return axios.put(`/sys/user/wm/info`, params);
};

////////////////网络表演个人信息/////////////////
//获取网络表演信息完善
export let getNpUserInfo = (params) => {
    return axios.get(`/sys/user/net/info/${params}`);
};

//获取网络表演信息编辑
export let putNpUserInfo = (params) => {
    return axios.put(`/sys/user/net/info`, params);
};

//当前账号的主体信息
export let getAuthSubject = () => {
    return axios.get(`/sys/auth/subject/client`);
};

//查询详情(会员信息)
export let getEntUserInfo = (params) => {
    return axios.get(`/client/ent/sys/user/info/${params}`);
};

//修改(会员信息)
export let putEntUserInfo = (params) => {
    return axios.put(`/client/ent/sys/user/info`, params);
};

//获取邮寄地址
export let getMailInfo = () => {
    return axios.get(`/sys/user/mail/`);
};

//修改邮寄地址
export let postMailInfo = (params) => {
    return axios.post(`/sys/user/mail`, params);
};

//获取发票信息
export let getInvoiceInfo = () => {
    return axios.get(`/sys/user/invoice/query`);
};

//修改发票信息
export let postInvoiceInfo = (params) => {
    return axios.post(`/sys/user/invoice`, params);
};

//获取各省会邮寄地址信息和资料
export let getOrganByRegionId = (params) => {
    return axios.get(`/sys/organ/byRegionId/${params}`);
};






// WEBPACK FOOTER //
// ./src/api/user.js